import { AuditInfo } from "../common/audit-info";
import { Document_Type } from "../../../constant/constant";

interface IImage {
    contentType: string
    fileName: string
    fileSize: string
    id: string
    location: string
}

export interface Document {
    id: string;
    auditInfo: AuditInfo;
    size: string;
    fileName: string;
    originalFileName: string;
    location: string;
    contentType: string;
    documentNumber?: string;
    documentPurpose: string;
    documentType: string | keyof typeof Document_Type;
    downloadLocation: string;
    status?: string;
    thumbnails?: {
        large: IImage;
        medium: IImage;
        small: IImage;
    }
    metaData?: Meta[];
}


export interface MetaData {
    metaDataCategory: string;
    metaField: string;
    metaFieldType: string;
    required: boolean;
    label: string;
}

export interface Meta extends MetaPayload {
    id?: string
}

export interface MetaPayload {
    metaField: string;
    metaValue: string|any;
    metaType: string;
    label: string;


}


export const META_FIELD_BEHAVIOR = {
    capturedDate: 'HYBRID',
    format: 'SYSTEM',
    location: 'HYBRID',
    camera: 'UI',
    description: 'UI',
    tag: 'UI',
    identityNumber: 'SYSTEM',
    issuedDate: 'UI'
}
